"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookieDomain = exports.getCookie = exports.createCookie = void 0;

var _EnvironmentUrl = _interopRequireDefault(require("../config/environment/EnvironmentUrl"));

var _EnvironmentTypes = _interopRequireDefault(require("../config/environment/EnvironmentTypes"));

var _AaPlatform = _interopRequireDefault(require("./AaPlatform"));

var createCookie = function createCookie(_ref) {
  var name = _ref.name,
      value = _ref.value,
      minutes = _ref.minutes,
      _ref$sameSite = _ref.sameSite,
      sameSite = _ref$sameSite === void 0 ? false : _ref$sameSite,
      domain = _ref.domain;
  if (!_AaPlatform["default"].IS_WEB) return;
  var isSecured = window.location.protocol === 'https:';
  var expires = '';

  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000);
    expires = 'expires=' + date.toGMTString();
  }

  document.cookie = "".concat(name, "=").concat(value, "; ").concat(expires, "; path=/; samesite=").concat(sameSite ? 'strict' : 'lax', "; domain=").concat(domain, "; ").concat(isSecured ? 'Secure' : '', ";");
};

exports.createCookie = createCookie;

var getCookie = function getCookie(name) {
  if (!_AaPlatform["default"].IS_WEB) return;
  var pattern = RegExp(name + '=.[^;]*');
  var matched = document.cookie.match(pattern);

  if (matched) {
    var cookie = matched[0].split('=');
    return cookie[1];
  }

  return null;
};

exports.getCookie = getCookie;

var getCookieDomain = function getCookieDomain() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _EnvironmentTypes["default"].PRODUCTION;
  var hostname = new URL(_EnvironmentUrl["default"][env].AA_BASE_URL).hostname;

  var removeSubdomain = function removeSubdomain(domain) {
    return domain.split('.').slice(-2).join('.');
  };

  return removeSubdomain(hostname);
};

exports.getCookieDomain = getCookieDomain;